import { useState, createRef} from "react";

const DataFilter = ({t, onClickFilterCallback, defaultKeyword}) => {

    const [refs] = useState({
      searchData: createRef(),
    });
    const [vars] = useState({
      searchData: defaultKeyword,
    });
    
    const onKeywordChange = ( e ) => {
        const { name, value } = e.target;
        //console.log(name + "  " + value);
        vars[name] = value;
    }
    const onClickSearch = () => {
        onClickFilterCallback( vars.searchData.trim());
    }
    const onClickClear = () => {
        refs.searchData.current.value = "";
        vars.searchData = "";
        onClickFilterCallback("");
    }
    return (
        <div className="form-group search-box">
            <input 
                id="searchData"
                name="searchData"
                ref={refs.searchData}
                defaultValue={vars.searchData}
                onChange={onKeywordChange}
                type="text"
                placeholder={t("page.search")}
                className="search-text"
            />
            <button
                type="submit"
                className="btn btn-primary btn-block search-button"
                onClick={onClickSearch}
              >
              <span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
              </button>
              
              <button className="btn btn-primary btn-block search-clear" onClick={onClickClear}>{t("page.clear")}
         		</button>
          </div>
    )
}

export default DataFilter;